import React, { useState } from 'react';
import { Typography, message } from 'antd';
import apiClient from '../services/apiClient';
import { useTranslation } from '../i18n';

const { Text } = Typography;

/** 订阅可读名，点铅笔就地改名（POST /api/user/subscription-info/rename）。 */
const SubscriptionNameText = ({ id, name, strong = true, onRenamed }) => {
    const { t } = useTranslation();
    const [value, setValue] = useState(name || `#${id}`);
    const save = async (next) => {
        const v = String(next || '').trim();
        if (!v || v === value) return;
        try {
            const r = await apiClient.post('/api/user/subscription-info/rename', { subscription_id: id, name: v });
            if (r.data?.success) {
                setValue(r.data.data.name);
                onRenamed && onRenamed(r.data.data.name);
            } else {
                message.error(r.data?.error || t('Rename failed'));
            }
        } catch (e) {
            message.error(e?.response?.data?.error || t('Rename failed'));
        }
    };
    return (
        <Text strong={strong} editable={{ onChange: save, maxLength: 40, tooltip: t('Rename') }} style={{ margin: 0 }}>
            {value}
        </Text>
    );
};

export default SubscriptionNameText;
